<div
  class="map-buttons-container"
  (click)="$event.stopPropagation()"
  (mousedown)="$event.stopPropagation()"
>
  <tc-scenarios-list
    class="map-button"
    [step]="step"
    [attributesMetadata]="attributesMetadata"
    [connectSettings]="connectSettings"
    [popupVisibilityChange]="isScenariosPopupVisible"
    (scenarioVisibilityChange)="onScenarioVisibilityChange($event)"
    (namespacesChange)="onNamespacesChange($event)"
    (popupStateChange)="checkScenarioPopupStatus($event)"
    (dblclick)="$event.stopPropagation()"
  ></tc-scenarios-list>
</div>

<div
  class="map-buttons-container legend-container"
  (click)="$event.stopPropagation()"
  (mousedown)="$event.stopPropagation()"
>
  <ct-map-legend-list
    [layers]="layers"
    [popupVisibilityChange]="isMapLegendPopupVisible"
    (popupStateChange)="checkMapLegendPopupStatus($event)"
  ></ct-map-legend-list>
</div>

<div
  class="map-buttons-container"
  (click)="$event.stopPropagation()"
  (mousedown)="$event.stopPropagation()"
>
  <ct-grid-map-selection-sync> </ct-grid-map-selection-sync>
</div>
